/*! JointJS+ v4.2.2 (2026-01-22) - HTML5 Diagramming Framework

Copyright (c) 2025 client IO

This Source Code Form is subject to the terms of the JointJS+
License, v. 2.0. If a copy of the JointJS+ License was not
distributed with this file, You can obtain one at
https://www.jointjs.com/license or from the JointJS+ archive as was
distributed by client IO. See the LICENSE file.
*/
import * as joint from '@joint/plus';
var KeyboardService = /** @class */ (function () {
    function KeyboardService() {
        this.keyboard = new joint.ui.Keyboard();
    }
    KeyboardService.prototype.create = function (graph, clipboard, selection, paperScroller, commandManager) {
        this.keyboard.on({
            'ctrl+c': function () {
                // Copy all selected elements and their associated links.
                clipboard.copyElements(selection.collection, graph);
            },
            'ctrl+v': function () {
                var pastedCells = clipboard.pasteCells(graph);
                var elements = pastedCells.filter(function (cell) { return cell.isElement(); });
                // Make sure pasted elements get selected immediately. This makes the UX better as
                // the user can immediately manipulate the pasted elements.
                selection.collection.reset(elements);
            },
            'ctrl+x shift+delete': function () {
                clipboard.cutElements(selection.collection, graph);
            },
            'delete backspace': function (evt) {
                evt.preventDefault();
                graph.removeCells(selection.collection.toArray());
            },
            'ctrl+z': function () {
                commandManager.undo();
                selection.cancelSelection();
            },
            'ctrl+y': function () {
                commandManager.redo();
                selection.cancelSelection();
            },
            'ctrl+a': function () {
                selection.collection.reset(graph.getElements());
            },
            'ctrl+plus': function (evt) {
                evt.preventDefault();
                paperScroller.zoom(0.2, { max: 5, grid: 0.2 });
            },
            'ctrl+minus': function (evt) {
                evt.preventDefault();
                paperScroller.zoom(-0.2, { min: 0.2, grid: 0.2 });
            },
            'keydown:shift': function (_evt) {
                paperScroller.setCursor('crosshair');
            },
            'keyup:shift': function () {
                paperScroller.setCursor('grab');
            }
        });
    };
    return KeyboardService;
}());
export { KeyboardService };
